import { cn } from '@/lib/utils';
import { User, Users } from 'lucide-react';
import { useNavigate, useLocation } from 'react-router-dom';

const SidebarSettingsRoutes = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const isActiveUsers = location.pathname.startsWith('/users');
  const isActiveGroups = location.pathname.startsWith('/groups');

  return (
    <>
      <div className="text-xs font-medium mb-2 mt-4 text-sidebar-foreground/70 px-2">
        Configurações
      </div>
      <div className="w-full space-y-1">
        <div
          onClick={() => navigate("/users")}
          className={cn(
            "flex items-center gap-3 py-2 px-3 rounded-lg transition-all duration-200 cursor-pointer sidebar-menu-item",
            "text-xs hover:bg-[#4B303C] hover:text-white border border-transparent hover:border-[#4B303C]",
            isActiveUsers
              ? "bg-[#4B303C] text-white border-[#4B303C] shadow-sm"
              : "text-gray-700 hover:shadow-sm",
          )}
        >
          <span className="transition-all duration-200 flex-shrink-0">
            <div className={cn(
              isActiveUsers ? "[&>svg]:text-white" : "[&>svg]:text-gray-500"
            )}>
              <User className="h-4 w-4" />
            </div>
          </span>
          <span className="font-medium">Usuários</span>
        </div>
        <div
          onClick={() => navigate("/groups")}
          className={cn(
            "flex items-center gap-3 py-2 px-3 rounded-lg transition-all duration-200 cursor-pointer sidebar-menu-item",
            "text-xs hover:bg-[#4B303C] hover:text-white border border-transparent hover:border-[#4B303C]",
            isActiveGroups
              ? "bg-[#4B303C] text-white border-[#4B303C] shadow-sm"
              : "text-gray-700 hover:shadow-sm",
          )}
        >
          <span className="transition-all duration-200 flex-shrink-0">
            <div className={cn(
              isActiveGroups ? "[&>svg]:text-white" : "[&>svg]:text-gray-500"
            )}>
              <Users className="h-4 w-4" />
            </div>
          </span>
          <span className="font-medium">Grupos e Rotas</span>
        </div>
      </div>
    </>
  );
};

export default SidebarSettingsRoutes;
